import { render, staticRenderFns } from "./event-tile.vue?vue&type=template&id=11aaae23&"
import script from "./event-tile.vue?vue&type=script&lang=js&"
export * from "./event-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports